import React from "react";

import { EmptyState, Page, PageHeader } from "../../../Ui/index.jsx";
import "../../../Styles/AdminPanel.css";

// What every tab of the admin panel shares: how long ago something was, one frame (page, heading, body)
// and the one line shown while a tab's answer is still on its way.

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const d = (Date.now() - new Date(iso).getTime()) / 86400000;
  if (d < 1) return "today";
  if (d < 2) return "yesterday";
  if (d < 30) return `${Math.floor(d)}d ago`;
  if (d < 365) return `${Math.floor(d / 30)}mo ago`;
  return `${Math.floor(d / 365)}y ago`;
};

export function AdminTab({ title, subtitle, actions, children }) {
  return (
    <Page>
      <PageHeader title={title} subtitle={subtitle} actions={actions} />
      {children}
    </Page>
  );
}

export function TabLoading({ children = "Loading…" }) {
  return <Page><EmptyState>{children}</EmptyState></Page>;
}

// The window pickers (7 / 14 / 30 days) of the usage and defaulter tabs.
export const dayWindows = (days) => days.map((n) => ({ value: n, label: `${n}d` }));
